// @flow
import type {StateType as GlobalState} from '../../reducers';
import type {ActionType} from './actions';
import mapKeys from 'lodash/mapKeys';

const initialState: AvailablePhoneNumbersStateType = {
  shownPhoneNumbers: [],
  currentPhoneNumber: null,
  entities: {},
};

export default function (
  state: AvailablePhoneNumbersStateType = initialState,
  action: ActionType,
) {
  switch (action.type) {
    case 'STORE_PHONE_NUMBERS':
      if (!action.phoneNumbers || !action.phoneNumbers.length) {
        return initialState;
      }

      return {
        ...state,
        entities: mapKeys(action.phoneNumbers, value => value.ouid),
      };

    case 'SHOW_NEW_PHONE_NUMBERS':
      //$FlowFixMe Object.values
      const newPhoneNumbers = Object.values(state.entities)
        .slice(0, 10)
        //$FlowFixMe Object.values
        .map(item => item.ouid);
      return {
        ...state,
        currentPhoneNumber:
          newPhoneNumbers[Math.floor(newPhoneNumbers.length / 2)],
        shownPhoneNumbers: newPhoneNumbers,
      };

    case 'SET_CURRENT_PHONE_NUMBER':
      return {
        ...state,
        currentPhoneNumber: action.currentPhoneNumber,
      };

    case 'DELETE_CURRENT_SHOWN_PHONE_NUMBERS':
      const newEntities = {...state.entities};
      state.shownPhoneNumbers.forEach(
        phoneNumberOuid => delete newEntities[phoneNumberOuid],
      );
      return {
        ...state,
        entities: newEntities,
        shownPhoneNumbers: [],
        currentPhoneNumber: null,
      };

    default:
      return state;
  }
}

export type AvailablePhoneNumbersStateType = {
  shownPhoneNumbers: string[],
  currentPhoneNumber: ?string,
  entities: {[string]: {ouid: string, phoneNumber: string}},
};

const availablePhoneNumbersState = (state: GlobalState) =>
  state.signUp.availablePhoneNumbers;

export const storedPhoneNumbersCountSelector = (state: GlobalState) =>
  Object.keys(availablePhoneNumbersState(state).entities).length;

export const phoneNumberSelector = (state: GlobalState, ouid: string) =>
  availablePhoneNumbersState(state).entities[ouid];

export const phoneNumbersSelector = (state: GlobalState) =>
  availablePhoneNumbersState(state).shownPhoneNumbers.map(ouid =>
    phoneNumberSelector(state, ouid),
  );

export const currentPhoneNumberSelector = (state: GlobalState) =>
  availablePhoneNumbersState(state).currentPhoneNumber;
